import React from 'react';
import { Box, Button, Chip, MenuItem, TextField, Typography } from '@mui/material';
import { MANAGER_ALL_ASSIGNEES_LABEL } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/constants.ts';
import { useManagerAssigneeFilterMenuItems } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/hooks/useManagerAssigneeFilterMenuItems.ts';
import { dataFormStyles } from '~/modules/covenants/CovenantsDataForm/styles.ts';
import { managerComponentStyles } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/components/styles.ts';

interface IManagerAssigneeFilterMenuItemsProps {
  assigneeOptions: string[];
  selectedAssignee: string[];
  closeMenu: () => void;
  onSelectAssignee: (assignee: string[]) => void;
}

export const AssigneeFilterMenuItems: React.FC<IManagerAssigneeFilterMenuItemsProps> = ({
  assigneeOptions,
  selectedAssignee,
  closeMenu,
  onSelectAssignee,
}) => {
  const {
    query,
    draftSelectedAssignees,
    handleApply,
    handleQueryChange,
    handleQueryKeyDown,
    handleRemoveAssignee,
    handleReset,
  } = useManagerAssigneeFilterMenuItems({
    assigneeOptions,
    selectedAssignee,
    closeMenu,
    onSelectAssignee,
  });

  return (
    <Box sx={managerComponentStyles.assigneeMenu}>
      <MenuItem
        selected={!draftSelectedAssignees.length}
        onClick={handleReset}
        sx={dataFormStyles.filterMenuItem}
      >
        <Typography variant="body2">{MANAGER_ALL_ASSIGNEES_LABEL}</Typography>
      </MenuItem>

      <Box sx={managerComponentStyles.assigneeSearch}>
        <TextField
          fullWidth
          size="small"
          value={query}
          onChange={(event) => {
            handleQueryChange(event.target.value);
          }}
          onKeyDown={(event) => {
            if (!handleQueryKeyDown(event.key)) {
              return;
            }

            event.preventDefault();
          }}
          placeholder="Введіть виконавця"
        />
      </Box>

      {!!draftSelectedAssignees.length && (
        <Box sx={managerComponentStyles.assigneeSelected}>
          {draftSelectedAssignees.map((assignee) => (
            <Chip
              key={assignee}
              label={assignee}
              onDelete={() => {
                handleRemoveAssignee(assignee);
              }}
              variant="outlined"
              size="small"
              sx={managerComponentStyles.assigneeChip}
            />
          ))}
        </Box>
      )}

      <Box sx={managerComponentStyles.assigneeFilterActions}>
        <Button size="small" variant="contained" onClick={handleApply}>
          Готово
        </Button>
      </Box>
    </Box>
  );
};

